import React from 'react';

import { LegacyText, TableCell } from '@gogame/components';

import {
  NameLinkStyled,
  NameBox,
} from 'scenes/MarketingPlanning/MarketingPlanningWizard/MarketingPlanningPreview/components';
import Comment from 'scenes/MarketingPlanning/MarketingPlanningWizard/MarketingPlanningPreview/components/Comment';
import {
  BudgetAllocated,
  BudgetAmount,
  BudgetPercent,
  BudgetDaily,
  Metric,
  CMetric,
} from 'scenes/MarketingPlanning/MarketingPlanningWizard/MarketingPlanningPreview/components/ValueConsumers';
import {
  ActivityTypesIndicator,
  TableRowActivityTypes,
  TableCellDefaultBackground,
} from 'scenes/MarketingPlanning/MarketingPlanningWizard/components';
import {
  GroupActivityType,
  GroupMetricsProvider,
  GroupCMetricsProvider,
} from 'scenes/MarketingPlanning/MarketingPlanningWizard/components/Group';
import { useViewStateByResolveName } from 'scenes/MarketingPlanning/MarketingPlanningWizard/components/ViewState';
import { getMetricTypeById } from 'scenes/MarketingPlanning/utils';

const Row = ({
  entityId,
  activityType,
  activityTypeIndex,
  activityTypeLength,
  withLinkName,
  withCBudgetEmpty,
}) => {
  const { name, metricTypes } = useViewStateByResolveName();

  return (
    <TableRowActivityTypes type={activityType} label={name}>
      <GroupActivityType type={activityType}>
        {activityTypeIndex === 0 ? (
          <TableCellDefaultBackground rowSpan={activityTypeLength}>
            <NameBox>
              {withLinkName ? (
                <NameLinkStyled to={`${entityId}`}>{name}</NameLinkStyled>
              ) : (
                <LegacyText>{name}</LegacyText>
              )}
            </NameBox>
          </TableCellDefaultBackground>
        ) : null}
        <TableCellDefaultBackground padding={'none'}>
          <ActivityTypesIndicator type={activityType} />
        </TableCellDefaultBackground>
        <TableCell align={'right'}>
          {withCBudgetEmpty ? '-' : <BudgetAllocated />}
        </TableCell>
        <TableCell align={'right'}>
          <BudgetAmount />
        </TableCell>
        <TableCell align={'right'}>
          <BudgetPercent />
        </TableCell>
        <TableCell align={'right'}>
          <BudgetDaily />
        </TableCell>
        {metricTypes.map(({ id, kindId }) => {
          const typeField = getMetricTypeById(kindId);
          return (
            <React.Fragment key={`nodes_table_row_metric_group_${id}`}>
              <GroupMetricsProvider>
                <TableCell align={'right'}>
                  <Metric name={id} typeField={typeField} />
                </TableCell>
              </GroupMetricsProvider>
              <GroupCMetricsProvider>
                <TableCell align={'right'}>
                  <CMetric name={id} typeField={typeField} />
                </TableCell>
              </GroupCMetricsProvider>
            </React.Fragment>
          );
        })}
        <TableCell>
          <Comment />
        </TableCell>
        <TableCell />
      </GroupActivityType>
    </TableRowActivityTypes>
  );
};

export default Row;
